import { FeathersModel } from './feathersModel'

export class CareType extends FeathersModel {
  static serviceName = 'care-types'

  socialServiceTypeId: number
  name: string
  shortName?: string | null
  createdAt?: string
  updatedAt?: string
}
